import { getCardConfig } from './cardConfig'
import { useMediaQuery } from '@/hooks/useMediaQuery'

// Below the tablet breakpoint an overview switches from the multi-column table
// to a stacked card layout (see OverviewCardList). Matches the tablet tier used
// by EntitySearchHeader so the header and body respond at the same width.
export const TABLET_MAX_WIDTH = 1199

/**
 * Whether an overview should render as cards instead of the table: the viewport
 * is tablet-sized or smaller and the entity has a {@link CardConfig}. Shared by
 * {@link EntityTable} (which renders the cards) and the overview widget (which
 * relocates the count indicator into the card header), so both switch at
 * exactly the same width.
 */
export const useIsCardView = (dataClassName?: string): boolean => {
  const isTabletOrBelow = useMediaQuery(`(max-width: ${TABLET_MAX_WIDTH}px)`)

  return isTabletOrBelow && !!getCardConfig(dataClassName)
}
